import PropTypes from 'prop-types';

export default function Select({ label, options, onChange, selected, testId = '' }) {
	return (
		<div className="form-field" data-field-type="select">
			{label ? <label>{label}</label> : null}
			<select defaultValue={selected} onChange={(e) => onChange(e.target.value)} data-testid={testId}>
				{options.map((option, index) => (
					<option key={index} value={option.value}>
						{option.label}
					</option>
				))}
			</select>
		</div>
	);
}

Select.propTypes = {
	label: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	options: PropTypes.array.isRequired,
	selected: PropTypes.any,
	testId: PropTypes.string,
};
